import React from "react";

import { UserManagement } from "@components/User";

export default function UserIndex() {
  return (
    <UserManagement
      isIndex
      requestInfo={{
        url: `/retrieve-users/`,
        data: {},
      }}
    />
  );
}
